import { CommonAPI } from "../Client";

export const getTenantCustomerApi = (customerId) =>
  CommonAPI.get("/tenant/customer", { params: { customerId } });

export const updateTenantCustomerApi = (payload) =>
  CommonAPI.put("/tenant/customer", payload);

export const createTenantCustomerApi = (payload) =>
  CommonAPI.post("/tenant/customer", payload);

export const uploadTenantCustomerFilesApi = ({ customerId, files = [] }) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));

  return CommonAPI.post(`/tenant/customer/${customerId}/uploads`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getTenantCustomersApi = ({
  page = 0,
  size = 100,
  sortBy = "customerId",
  sortDir = "desc",
  search = "",
} = {}) =>
  CommonAPI.get("/tenant/customers", {
    params: { page, size, sortBy, sortDir, search: search || undefined },
  });

export const getTenantCustomerByCodeApi = (customerCode) =>
  CommonAPI.get("/tenant/customer/code", { params: { customerCode } });

export const deleteTenantCustomerUploadApi = (uploadId) =>
  CommonAPI.delete("/tenant/customer/uploads", { params: { uploadId } });
